// Textos propis de la pàgina "galeria" per idioma (Galeria.jsx).

const textos = {
    es: {
        heroImageAlt: "Galería de fotos del Hotel Camprodon",
        heroSmallTitle: "Imagina tu estancia con nosotros",
        heroTitle: "Galería de fotos del Hotel Camprodon",
        stickyWidgetsButtonHref: "/buscar2",
        stickyWidgetsButtonHref2: "/restaurante#reserva-restaurant",
        sectionHeadTitle: "Servicios e instalaciones de Hotel Camprodon",
        sectionHeadTexts: "Descubre en la siguiente galería de imágenes el estilo modernista del Hotel Camprodon, que tanto caracteriza sus cálidos interiores.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galeria",
        galleryItemAlt2: "Galeria",
        galleryItemAlt3: "Galeria",
        galleryItemAlt4: "Galeria",
        galleryItemAlt5: "Galeria",
        galleryItemAlt6: "Galeria",
        galleryItemAlt7: "Galeria",
        galleryItemAlt8: "Galeria",
        galleryItemAlt9: "Galeria",
        galleryItemAlt10: "Galeria",
        galleryItemAlt11: "Galeria",
        galleryItemAlt12: "Galeria",
        galleryItemAlt13: "Galeria",
        galleryItemAlt14: "Galeria",
        galleryItemAlt15: "Galeria",
        galleryItemAlt16: "Galeria",
        galleryItemAlt17: "Galeria",
        galleryItemAlt18: "Galeria",
        galleryItemAlt19: "Galeria",
        galleryItemAlt20: "Galeria",
        galleryItemAlt21: "Galeria",
        galleryItemAlt22: "Galeria",
        galleryItemAlt23: "Galeria",
        galleryItemAlt24: "Galeria",
        galleryItemAlt25: "Galeria",
        galleryItemAlt26: "Galeria",
        galleryItemAlt27: "Galeria",
        galleryItemAlt28: "Galeria",
        galleryItemAlt29: "Galeria",
        galleryItemAlt30: "Galeria",
        galleryItemAlt31: "Galeria",
        galleryItemAlt32: "Galeria",
        galleryItemAlt33: "Galeria",
        galleryItemAlt34: "Galeria",
    },
    ca: {
        heroImageAlt: "Galeria de fotos de l'Hotel Camprodon",
        heroSmallTitle: "Imagina la teva estada amb nosaltres",
        heroTitle: "Galeria de fotos de l'Hotel Camprodon",
        stickyWidgetsButtonHref: "/ca/buscar2",
        stickyWidgetsButtonHref2: "/ca/restaurant#reserva-restaurant",
        sectionHeadTitle: "Serveis i instal·lacions de l'Hotel Camprodon",
        sectionHeadTexts: "Descobreix a la següent galeria d'imatges l'estil modernista de l'Hotel Camprodon que tant caracteritza els seus càlids interiors.",
        galleryFilter: "Totes",
        galleryFilter2: "Piscina i jardí",
        galleryFilter3: "Terrassa",
        galleryFilter4: "Exteriors",
        galleryFilter5: "Habitacions",
        galleryFilter6: "Interiors",
        galleryFilter7: "Restaurant",
        galleryFilter8: "Esdeveniments",
        galleryItemAlt: "Galeria",
        galleryItemAlt2: "Galeria",
        galleryItemAlt3: "Galeria",
        galleryItemAlt4: "Galeria",
        galleryItemAlt5: "Galeria",
        galleryItemAlt6: "Galeria",
        galleryItemAlt7: "Galeria",
        galleryItemAlt8: "Galeria",
        galleryItemAlt9: "Galeria",
        galleryItemAlt10: "Galeria",
        galleryItemAlt11: "Galeria",
        galleryItemAlt12: "Galeria",
        galleryItemAlt13: "Galeria",
        galleryItemAlt14: "Galeria",
        galleryItemAlt15: "Galeria",
        galleryItemAlt16: "Galeria",
        galleryItemAlt17: "Galeria",
        galleryItemAlt18: "Galeria",
        galleryItemAlt19: "Galeria",
        galleryItemAlt20: "Galeria",
        galleryItemAlt21: "Galeria",
        galleryItemAlt22: "Galeria",
        galleryItemAlt23: "Galeria",
        galleryItemAlt24: "Galeria",
        galleryItemAlt25: "Galeria",
        galleryItemAlt26: "Galeria",
        galleryItemAlt27: "Galeria",
        galleryItemAlt28: "Galeria",
        galleryItemAlt29: "Galeria",
        galleryItemAlt30: "Galeria",
        galleryItemAlt31: "Galeria",
        galleryItemAlt32: "Galeria",
        galleryItemAlt33: "Galeria",
        galleryItemAlt34: "Galeria",
    },
    en: {
        heroImageAlt: "Photo gallery at Hotel Camprodon",
        heroSmallTitle: "Imagine your stay with us",
        heroTitle: "Photo gallery at Hotel Camprodon",
        stickyWidgetsButtonHref: "/en/buscar2",
        stickyWidgetsButtonHref2: "/en/restaurant#reserva-restaurant",
        sectionHeadTitle: "Services and facilities of Hotel Camprodon",
        sectionHeadTexts: "Discover in the following gallery of images the modernist style of the Hotel Camprodon that so characterizes its warm interiors.",
        galleryFilter: "All",
        galleryFilter2: "Swimming pool and garden",
        galleryFilter3: "Terrace",
        galleryFilter4: "Exteriors",
        galleryFilter5: "Rooms",
        galleryFilter6: "Interiors",
        galleryFilter7: "Restaurant",
        galleryFilter8: "Events",
        galleryItemAlt: "Galeria",
        galleryItemAlt2: "Galeria",
        galleryItemAlt3: "Galeria",
        galleryItemAlt4: "Galeria",
        galleryItemAlt5: "Galeria",
        galleryItemAlt6: "Galeria",
        galleryItemAlt7: "Galeria",
        galleryItemAlt8: "Galeria",
        galleryItemAlt9: "Galeria",
        galleryItemAlt10: "Galeria",
        galleryItemAlt11: "Galeria",
        galleryItemAlt12: "Galeria",
        galleryItemAlt13: "Galeria",
        galleryItemAlt14: "Galeria",
        galleryItemAlt15: "Galeria",
        galleryItemAlt16: "Galeria",
        galleryItemAlt17: "Galeria",
        galleryItemAlt18: "Galeria",
        galleryItemAlt19: "Galeria",
        galleryItemAlt20: "Galeria",
        galleryItemAlt21: "Galeria",
        galleryItemAlt22: "Galeria",
        galleryItemAlt23: "Galeria",
        galleryItemAlt24: "Galeria",
        galleryItemAlt25: "Galeria",
        galleryItemAlt26: "Galeria",
        galleryItemAlt27: "Galeria",
        galleryItemAlt28: "Galeria",
        galleryItemAlt29: "Galeria",
        galleryItemAlt30: "Galeria",
        galleryItemAlt31: "Galeria",
        galleryItemAlt32: "Galeria",
        galleryItemAlt33: "Galeria",
        galleryItemAlt34: "Galeria",
    },
    fr: {
        heroImageAlt: "Galerie de photos de l'Hotel Camprodon",
        heroSmallTitle: "Imaginez votre séjour chez nous",
        heroTitle: "Galerie de photos de l'Hotel Camprodon",
        stickyWidgetsButtonHref: "/fr/buscar2",
        stickyWidgetsButtonHref2: "/fr/restaurant#reserva-restaurant",
        sectionHeadTitle: "Services et installations de l'Hotel Camprodon",
        sectionHeadTexts: "Découvrez dans la galerie d'images suivante le style moderniste de l'Hotel Camprodon, qui caractérise si bien ses intérieurs chaleureux.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galerie",
        galleryItemAlt2: "Galerie",
        galleryItemAlt3: "Galerie",
        galleryItemAlt4: "Galerie",
        galleryItemAlt5: "Galerie",
        galleryItemAlt6: "Galerie",
        galleryItemAlt7: "Galerie",
        galleryItemAlt8: "Galerie",
        galleryItemAlt9: "Galerie",
        galleryItemAlt10: "Galerie",
        galleryItemAlt11: "Galerie",
        galleryItemAlt12: "Galerie",
        galleryItemAlt13: "Galerie",
        galleryItemAlt14: "Galerie",
        galleryItemAlt15: "Galerie",
        galleryItemAlt16: "Galerie",
        galleryItemAlt17: "Galerie",
        galleryItemAlt18: "Galerie",
        galleryItemAlt19: "Galerie",
        galleryItemAlt20: "Galerie",
        galleryItemAlt21: "Galerie",
        galleryItemAlt22: "Galerie",
        galleryItemAlt23: "Galerie",
        galleryItemAlt24: "Galerie",
        galleryItemAlt25: "Galerie",
        galleryItemAlt26: "Galerie",
        galleryItemAlt27: "Galerie",
        galleryItemAlt28: "Galerie",
        galleryItemAlt29: "Galerie",
        galleryItemAlt30: "Galerie",
        galleryItemAlt31: "Galerie",
        galleryItemAlt32: "Galerie",
        galleryItemAlt33: "Galerie",
        galleryItemAlt34: "Galerie",
    },
    de: {
        heroImageAlt: "Fotogalerie des Hotel Camprodon",
        heroSmallTitle: "Stellen Sie sich Ihren Aufenthalt bei uns vor",
        heroTitle: "Fotogalerie des Hotel Camprodon",
        stickyWidgetsButtonHref: "/de/buscar2",
        stickyWidgetsButtonHref2: "/de/restaurante#reserva-restaurant",
        sectionHeadTitle: "Leistungen und Einrichtungen des Hotel Camprodon",
        sectionHeadTexts: "Entdecken Sie in der folgenden Bildergalerie den Jugendstil des Hotel Camprodon, der seine warmen Innenräume so sehr prägt.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galerie",
        galleryItemAlt2: "Galerie",
        galleryItemAlt3: "Galerie",
        galleryItemAlt4: "Galerie",
        galleryItemAlt5: "Galerie",
        galleryItemAlt6: "Galerie",
        galleryItemAlt7: "Galerie",
        galleryItemAlt8: "Galerie",
        galleryItemAlt9: "Galerie",
        galleryItemAlt10: "Galerie",
        galleryItemAlt11: "Galerie",
        galleryItemAlt12: "Galerie",
        galleryItemAlt13: "Galerie",
        galleryItemAlt14: "Galerie",
        galleryItemAlt15: "Galerie",
        galleryItemAlt16: "Galerie",
        galleryItemAlt17: "Galerie",
        galleryItemAlt18: "Galerie",
        galleryItemAlt19: "Galerie",
        galleryItemAlt20: "Galerie",
        galleryItemAlt21: "Galerie",
        galleryItemAlt22: "Galerie",
        galleryItemAlt23: "Galerie",
        galleryItemAlt24: "Galerie",
        galleryItemAlt25: "Galerie",
        galleryItemAlt26: "Galerie",
        galleryItemAlt27: "Galerie",
        galleryItemAlt28: "Galerie",
        galleryItemAlt29: "Galerie",
        galleryItemAlt30: "Galerie",
        galleryItemAlt31: "Galerie",
        galleryItemAlt32: "Galerie",
        galleryItemAlt33: "Galerie",
        galleryItemAlt34: "Galerie",
    },
    it: {
        heroImageAlt: "Galleria fotografica dell'Hotel Camprodon",
        heroSmallTitle: "Immagina il tuo soggiorno con noi",
        heroTitle: "Galleria fotografica dell'Hotel Camprodon",
        stickyWidgetsButtonHref: "/it/buscar2",
        stickyWidgetsButtonHref2: "/it/restaurante#reserva-restaurant",
        sectionHeadTitle: "Servizi e strutture dell'Hotel Camprodon",
        sectionHeadTexts: "Scopri nella seguente galleria di immagini lo stile modernista dell'Hotel Camprodon, che caratterizza i suoi caldi interni.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galleria",
        galleryItemAlt2: "Galleria",
        galleryItemAlt3: "Galleria",
        galleryItemAlt4: "Galleria",
        galleryItemAlt5: "Galleria",
        galleryItemAlt6: "Galleria",
        galleryItemAlt7: "Galleria",
        galleryItemAlt8: "Galleria",
        galleryItemAlt9: "Galleria",
        galleryItemAlt10: "Galleria",
        galleryItemAlt11: "Galleria",
        galleryItemAlt12: "Galleria",
        galleryItemAlt13: "Galleria",
        galleryItemAlt14: "Galleria",
        galleryItemAlt15: "Galleria",
        galleryItemAlt16: "Galleria",
        galleryItemAlt17: "Galleria",
        galleryItemAlt18: "Galleria",
        galleryItemAlt19: "Galleria",
        galleryItemAlt20: "Galleria",
        galleryItemAlt21: "Galleria",
        galleryItemAlt22: "Galleria",
        galleryItemAlt23: "Galleria",
        galleryItemAlt24: "Galleria",
        galleryItemAlt25: "Galleria",
        galleryItemAlt26: "Galleria",
        galleryItemAlt27: "Galleria",
        galleryItemAlt28: "Galleria",
        galleryItemAlt29: "Galleria",
        galleryItemAlt30: "Galleria",
        galleryItemAlt31: "Galleria",
        galleryItemAlt32: "Galleria",
        galleryItemAlt33: "Galleria",
        galleryItemAlt34: "Galleria",
    },
    pt: {
        heroImageAlt: "Galeria de fotos do Hotel Camprodon",
        heroSmallTitle: "Imagine a sua estadia connosco",
        heroTitle: "Galeria de fotos do Hotel Camprodon",
        stickyWidgetsButtonHref: "/pt/buscar2",
        stickyWidgetsButtonHref2: "/pt/restaurante#reserva-restaurant",
        sectionHeadTitle: "Serviços e instalações do Hotel Camprodon",
        sectionHeadTexts: "Descubra na seguinte galeria de imagens o estilo modernista do Hotel Camprodon, que tanto caracteriza os seus interiores acolhedores.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galeria",
        galleryItemAlt2: "Galeria",
        galleryItemAlt3: "Galeria",
        galleryItemAlt4: "Galeria",
        galleryItemAlt5: "Galeria",
        galleryItemAlt6: "Galeria",
        galleryItemAlt7: "Galeria",
        galleryItemAlt8: "Galeria",
        galleryItemAlt9: "Galeria",
        galleryItemAlt10: "Galeria",
        galleryItemAlt11: "Galeria",
        galleryItemAlt12: "Galeria",
        galleryItemAlt13: "Galeria",
        galleryItemAlt14: "Galeria",
        galleryItemAlt15: "Galeria",
        galleryItemAlt16: "Galeria",
        galleryItemAlt17: "Galeria",
        galleryItemAlt18: "Galeria",
        galleryItemAlt19: "Galeria",
        galleryItemAlt20: "Galeria",
        galleryItemAlt21: "Galeria",
        galleryItemAlt22: "Galeria",
        galleryItemAlt23: "Galeria",
        galleryItemAlt24: "Galeria",
        galleryItemAlt25: "Galeria",
        galleryItemAlt26: "Galeria",
        galleryItemAlt27: "Galeria",
        galleryItemAlt28: "Galeria",
        galleryItemAlt29: "Galeria",
        galleryItemAlt30: "Galeria",
        galleryItemAlt31: "Galeria",
        galleryItemAlt32: "Galeria",
        galleryItemAlt33: "Galeria",
        galleryItemAlt34: "Galeria",
    },
    nl: {
        heroImageAlt: "Fotogalerij van Hotel Camprodon",
        heroSmallTitle: "Stel je je verblijf bij ons voor",
        heroTitle: "Fotogalerij van Hotel Camprodon",
        stickyWidgetsButtonHref: "/nl/buscar2",
        stickyWidgetsButtonHref2: "/nl/restaurante#reserva-restaurant",
        sectionHeadTitle: "Diensten en faciliteiten van Hotel Camprodon",
        sectionHeadTexts: "Ontdek in de onderstaande fotogalerij de modernistische stijl van Hotel Camprodon, die zo kenmerkend is voor de warme interieurs.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galerij",
        galleryItemAlt2: "Galerij",
        galleryItemAlt3: "Galerij",
        galleryItemAlt4: "Galerij",
        galleryItemAlt5: "Galerij",
        galleryItemAlt6: "Galerij",
        galleryItemAlt7: "Galerij",
        galleryItemAlt8: "Galerij",
        galleryItemAlt9: "Galerij",
        galleryItemAlt10: "Galerij",
        galleryItemAlt11: "Galerij",
        galleryItemAlt12: "Galerij",
        galleryItemAlt13: "Galerij",
        galleryItemAlt14: "Galerij",
        galleryItemAlt15: "Galerij",
        galleryItemAlt16: "Galerij",
        galleryItemAlt17: "Galerij",
        galleryItemAlt18: "Galerij",
        galleryItemAlt19: "Galerij",
        galleryItemAlt20: "Galerij",
        galleryItemAlt21: "Galerij",
        galleryItemAlt22: "Galerij",
        galleryItemAlt23: "Galerij",
        galleryItemAlt24: "Galerij",
        galleryItemAlt25: "Galerij",
        galleryItemAlt26: "Galerij",
        galleryItemAlt27: "Galerij",
        galleryItemAlt28: "Galerij",
        galleryItemAlt29: "Galerij",
        galleryItemAlt30: "Galerij",
        galleryItemAlt31: "Galerij",
        galleryItemAlt32: "Galerij",
        galleryItemAlt33: "Galerij",
        galleryItemAlt34: "Galerij",
    },
    cs: {
        heroImageAlt: "Fotogalerie hotelu Hotel Camprodon",
        heroSmallTitle: "Představte si svůj pobyt u nás",
        heroTitle: "Fotogalerie hotelu Hotel Camprodon",
        stickyWidgetsButtonHref: "/cs/buscar2",
        stickyWidgetsButtonHref2: "/cs/restaurante#reserva-restaurant",
        sectionHeadTitle: "Služby a vybavení hotelu Hotel Camprodon",
        sectionHeadTexts: "V následující galerii objevte secesní styl hotelu Hotel Camprodon, který tak charakterizuje jeho útulné interiéry.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galerie",
        galleryItemAlt2: "Galerie",
        galleryItemAlt3: "Galerie",
        galleryItemAlt4: "Galerie",
        galleryItemAlt5: "Galerie",
        galleryItemAlt6: "Galerie",
        galleryItemAlt7: "Galerie",
        galleryItemAlt8: "Galerie",
        galleryItemAlt9: "Galerie",
        galleryItemAlt10: "Galerie",
        galleryItemAlt11: "Galerie",
        galleryItemAlt12: "Galerie",
        galleryItemAlt13: "Galerie",
        galleryItemAlt14: "Galerie",
        galleryItemAlt15: "Galerie",
        galleryItemAlt16: "Galerie",
        galleryItemAlt17: "Galerie",
        galleryItemAlt18: "Galerie",
        galleryItemAlt19: "Galerie",
        galleryItemAlt20: "Galerie",
        galleryItemAlt21: "Galerie",
        galleryItemAlt22: "Galerie",
        galleryItemAlt23: "Galerie",
        galleryItemAlt24: "Galerie",
        galleryItemAlt25: "Galerie",
        galleryItemAlt26: "Galerie",
        galleryItemAlt27: "Galerie",
        galleryItemAlt28: "Galerie",
        galleryItemAlt29: "Galerie",
        galleryItemAlt30: "Galerie",
        galleryItemAlt31: "Galerie",
        galleryItemAlt32: "Galerie",
        galleryItemAlt33: "Galerie",
        galleryItemAlt34: "Galerie",
    },
    ru: {
        heroImageAlt: "Фотогалерея Hotel Camprodon",
        heroSmallTitle: "Представьте свой отдых у нас",
        heroTitle: "Фотогалерея Hotel Camprodon",
        stickyWidgetsButtonHref: "/ru/buscar2",
        stickyWidgetsButtonHref2: "/ru/restaurante#reserva-restaurant",
        sectionHeadTitle: "Услуги и удобства Hotel Camprodon",
        sectionHeadTexts: "В галерее ниже — стиль модерн Hotel Camprodon, которым так отличаются его тёплые интерьеры.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Галерея",
        galleryItemAlt2: "Галерея",
        galleryItemAlt3: "Галерея",
        galleryItemAlt4: "Галерея",
        galleryItemAlt5: "Галерея",
        galleryItemAlt6: "Галерея",
        galleryItemAlt7: "Галерея",
        galleryItemAlt8: "Галерея",
        galleryItemAlt9: "Галерея",
        galleryItemAlt10: "Галерея",
        galleryItemAlt11: "Галерея",
        galleryItemAlt12: "Галерея",
        galleryItemAlt13: "Галерея",
        galleryItemAlt14: "Галерея",
        galleryItemAlt15: "Галерея",
        galleryItemAlt16: "Галерея",
        galleryItemAlt17: "Галерея",
        galleryItemAlt18: "Галерея",
        galleryItemAlt19: "Галерея",
        galleryItemAlt20: "Галерея",
        galleryItemAlt21: "Галерея",
        galleryItemAlt22: "Галерея",
        galleryItemAlt23: "Галерея",
        galleryItemAlt24: "Галерея",
        galleryItemAlt25: "Галерея",
        galleryItemAlt26: "Галерея",
        galleryItemAlt27: "Галерея",
        galleryItemAlt28: "Галерея",
        galleryItemAlt29: "Галерея",
        galleryItemAlt30: "Галерея",
        galleryItemAlt31: "Галерея",
        galleryItemAlt32: "Галерея",
        galleryItemAlt33: "Галерея",
        galleryItemAlt34: "Галерея",
    },
    sv: {
        heroImageAlt: "Fotogalleri från Hotel Camprodon",
        heroSmallTitle: "Föreställ dig din vistelse hos oss",
        heroTitle: "Fotogalleri från Hotel Camprodon",
        stickyWidgetsButtonHref: "/sv/buscar2",
        stickyWidgetsButtonHref2: "/sv/restaurante#reserva-restaurant",
        sectionHeadTitle: "Tjänster och faciliteter på Hotel Camprodon",
        sectionHeadTexts: "Upptäck i bildgalleriet nedan den modernistiska stil som så tydligt präglar de varma interiörerna på Hotel Camprodon.",
        galleryFilter: "Todas",
        galleryFilter2: "Piscina y jardín",
        galleryFilter3: "Terraza",
        galleryFilter4: "Exteriores",
        galleryFilter5: "Habitaciones",
        galleryFilter6: "Interiores",
        galleryFilter7: "Restaurante",
        galleryFilter8: "Eventos",
        galleryItemAlt: "Galleri",
        galleryItemAlt2: "Galleri",
        galleryItemAlt3: "Galleri",
        galleryItemAlt4: "Galleri",
        galleryItemAlt5: "Galleri",
        galleryItemAlt6: "Galleri",
        galleryItemAlt7: "Galleri",
        galleryItemAlt8: "Galleri",
        galleryItemAlt9: "Galleri",
        galleryItemAlt10: "Galleri",
        galleryItemAlt11: "Galleri",
        galleryItemAlt12: "Galleri",
        galleryItemAlt13: "Galleri",
        galleryItemAlt14: "Galleri",
        galleryItemAlt15: "Galleri",
        galleryItemAlt16: "Galleri",
        galleryItemAlt17: "Galleri",
        galleryItemAlt18: "Galleri",
        galleryItemAlt19: "Galleri",
        galleryItemAlt20: "Galleri",
        galleryItemAlt21: "Galleri",
        galleryItemAlt22: "Galleri",
        galleryItemAlt23: "Galleri",
        galleryItemAlt24: "Galleri",
        galleryItemAlt25: "Galleri",
        galleryItemAlt26: "Galleri",
        galleryItemAlt27: "Galleri",
        galleryItemAlt28: "Galleri",
        galleryItemAlt29: "Galleri",
        galleryItemAlt30: "Galleri",
        galleryItemAlt31: "Galleri",
        galleryItemAlt32: "Galleri",
        galleryItemAlt33: "Galleri",
        galleryItemAlt34: "Galleri",
    },
};

export default textos;
